import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/lang";

export default function Schedule() {
  const [data, setData] = useState(null);
  const { t, lang } = useLang();
  const [month, setMonth] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });
  useEffect(() => { api.get(`/driver/schedule?month=${month}`).then((r) => setData(r.data)); }, [month]);

  if (!data) return <div className="p-6 text-slate-500">Loading…</div>;

  const [year, mon] = month.split("-").map(Number);
  const daysInMonth = new Date(year, mon, 0).getDate();
  const firstDay = new Date(year, mon - 1, 1).getDay(); // 0=Sun, adjust
  const startOffset = (firstDay + 6) % 7; // start on Monday

  const tripsByDay = {};
  data.trips.forEach((t) => {
    const d = new Date(t.service_datetime).getDate();
    (tripsByDay[d] = tripsByDay[d] || []).push(t);
  });

  const shift = (delta) => {
    let m = mon + delta;
    let y = year;
    if (m < 1) { m = 12; y--; }
    if (m > 12) { m = 1; y++; }
    setMonth(`${y}-${String(m).padStart(2, "0")}`);
  };

  const monthName = new Date(year, mon - 1, 1).toLocaleDateString(lang === "PT" ? "pt-PT" : "en-GB", { month: "long", year: "numeric" });

  return (
    <div className="p-5">
      <p className="label-caps mb-1">{t("schedule")}</p>
      <div className="flex items-center justify-between mb-6">
        <button onClick={() => shift(-1)} className="text-slate-500 hover:text-[#f59e0b] text-2xl">‹</button>
        <h1 className="font-display text-2xl text-[#0a0f1e] capitalize">{monthName}</h1>
        <button onClick={() => shift(1)} className="text-slate-500 hover:text-[#f59e0b] text-2xl">›</button>
      </div>

      <div className="grid grid-cols-7 gap-1 text-center text-[10px] text-slate-500 mb-2 uppercase">
        {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((d) => <div key={d}>{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {Array.from({ length: startOffset }).map((_, i) => <div key={`e${i}`} />)}
        {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((day) => {
          const trips = tripsByDay[day] || [];
          const busy = trips.length > 0;
          return (
            <div key={day} data-testid={`cal-day-${day}`} className={`aspect-square border ${busy ? "border-[#f59e0b] bg-[#f59e0b]/10" : "border-slate-200"} p-1 relative`}>
              <div className={`text-xs ${busy ? "text-[#f59e0b] font-semibold" : "text-slate-500"}`}>{day}</div>
              {busy && (
                <div className="absolute bottom-1 left-1 right-1 text-[8px] text-[#f59e0b] uppercase">{trips.length} trip{trips.length > 1 ? "s" : ""}</div>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-8">
        <p className="label-caps mb-3">Trips this month</p>
        <div className="space-y-2">
          {data.trips.length === 0 && <div className="text-xs text-slate-500">Nothing scheduled.</div>}
          {data.trips.slice(0, 20).map((tr) => (
            <div key={tr.id} className="border border-slate-200 p-3 text-sm">
              <div className="flex justify-between">
                <div className="text-[#0a0f1e]">{new Date(tr.service_datetime).toLocaleString(lang === "PT" ? "pt-PT" : "en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
                <div className="text-[10px] uppercase text-slate-500">{tr.type}</div>
              </div>
              <div className="text-xs text-slate-500 mt-1">{tr.client_name} · €{tr.driver_earning?.toFixed(2)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
